import request from '@/api/hqzcApiRequest'

//获取欢迎语接口（不用传参）：
export function intelligentChatInit () {
    return request({
        url: "/pub/api/intelligentChat/init",
    })
}

//获取常见问题列表（带分页）：
export function intelligentChatCommon (data) {
    return request({
        url: "/pub/api/intelligentChat/common",
        method: "post",
        data
    })
}

//接收用户提问的问题（text：问题，source:来源(1是PC，2是H5，3是小程序)）：
export function intelligentChatChat (data) {
    return request({
        url: "/pub/api/intelligentChat/chat",
        method: "post",
        data
    })

}
//文字转换音频（合成音频）（text：问题，source:来源(1是PC，2是H5，3是小程序)）：
export function transitionAudio (data) {
    return request({
        url: "/pub/api/intelligentChat/transitionAudio",
        method: "post",
        data
    })
}
/**用户录音提问问题 */
export function intelligentChatAudio (data) {
    return request({
        url: "/pub/api/intelligentChat/audio",
        method: "post",
        data
    })
}

/**获取开启状态接口 */
export function getOpenEnabled () {
    return request({
        url: "/pub/api/intelligentChat/isEnabled",


    })
}

